import FormEngine, { FormEngineProps } from "@components/FormEngine/FormEngine";

import { regex } from "@utils/zod";

export const EMAIL_VERIF_FORM_ID = "email-verification-form";
type EmailVerificationFormProps = {
  data?: { email: string };
  onSubmit: FormEngineProps["onSubmit"];
} & Partial<FormEngineProps>;

const EmailVerificationForm = ({
  onSubmit,
  data,
  ...rest
}: EmailVerificationFormProps) => {
  return (
    <FormEngine
      formId={EMAIL_VERIF_FORM_ID}
      onSubmit={onSubmit}
      data={{
        email: data?.email || "",
      }}
      schema={[
        {
          name: "email",
          label: "Email Address",
          type: "input",
          rule: regex.email,
        },
      ]}
      {...rest}
    />
  );
};

export default EmailVerificationForm;
